<template>
  <div class="modal fade" id="modal_tiss_guide_confirmation" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-xl">
        <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Confirmar Emissão da Guia</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fechar"></button>
        </div>
        <form @submit.prevent="confirm">
          <div class="modal-body">
            <div class="alert alert-info">
              <i class="bi bi-info-circle me-2"></i>
              Revise os dados da Guia que será gerada antes de confirmar.
            </div>

            <div v-if="guidePreview" class="mb-4">
              <h6 class="fw-bold mb-3">Dados da Guia</h6>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">Tipo de Guia:</label>
                  <select v-model="guidePreview.guide_type" class="form-control" required>
                    <option value="CONSULTA">Consulta</option>
                    <option value="SP_SADT">Exames (SP/SADT)</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Data de Atendimento:</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="guidePreview.attendance_date"
                    required>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">Paciente:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.patient_name"
                    disabled>
                </div>
                <div class="col-md-6">
                  <label class="form-label">CPF:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.patient_cpf"
                    v-mask="'###.###.###-##'"
                    disabled>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">Profissional:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.professional_name"
                    disabled>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Especialidade:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.specialty_name"
                    disabled>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">Convênio:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.insurance_name"
                    disabled>
                </div>
                <div class="col-md-6">
                  <label class="form-label">Carteirinha:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.card_number"
                    disabled>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label class="form-label">Código do Procedimento:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.procedure_code"
                    maxlength="20"
                    required>
                  <small class="text-muted">Máximo de 20 caracteres.</small>
                </div>
                <div class="col-md-3">
                  <label class="form-label">Valor do Procedimento:</label>
                  <input
                    type="text"
                    class="form-control"
                    v-model="guidePreview.procedure_value"
                    disabled>
                </div>
                <div class="col-md-3">
                  <label class="form-label required">Valor para Repasse:</label>
                  <input
                    type="number"
                    class="form-control"
                    v-model.number="guidePreview.procedure_transfer_value"
                    min="0"
                    step="0.01"
                    required
                    placeholder="0.00">
                </div>
              </div>

              <div class="mb-3">
                <label class="form-label">Observações:</label>
                <textarea
                  class="form-control"
                  v-model="guidePreview.observations"
                  rows="2"
                  placeholder="Observações adicionais (opcional)"></textarea>
              </div>

              <div v-if="generatedGuide" class="border rounded p-4 bg-light">
                <div class="d-flex align-items-center justify-content-between gap-3 flex-wrap mb-3">
                  <div>
                    <h6 class="fw-bold mb-1">Cobrança da Guia</h6>
                    <div class="text-muted small">
                      Guia emitida com sucesso. Defina agora se haverá cobrança.
                    </div>
                  </div>
                  <span class="badge bg-success">Guia emitida</span>
                </div>

                <div v-if="askForCharge" class="d-flex flex-column gap-2">
                  <p
                    v-if="generatedGuide && !canGenerateChargeFromGuide"
                    class="text-warning small mb-0"
                  >
                    Cobrança só é permitida quando o valor da guia é maior que R$ 5,00.
                  </p>
                  <div class="d-flex align-items-center gap-2 flex-wrap">
                    <span class="fw-semibold">Haverá cobrança?</span>
                    <button
                      type="button"
                      class="btn btn-sm btn-primary"
                      :disabled="!canGenerateChargeFromGuide"
                      @click="onChargeDecision(true)"
                    >
                      Sim
                    </button>
                    <button type="button" class="btn btn-sm btn-light" @click="onChargeDecision(false)">
                      Não
                    </button>
                  </div>
                </div>

                <div v-else-if="selectingChargeMethod" class="d-flex align-items-center gap-2 flex-wrap">
                  <span class="fw-semibold">Como deseja cobrar?</span>
                  <button type="button" class="btn btn-sm btn-primary" :disabled="charging" @click="createCharge('pix')">
                    <i class="bi bi-qr-code me-1"></i>
                    Pix
                  </button>
                  <button type="button" class="btn btn-sm btn-primary" :disabled="charging" @click="createCharge('bank_slip')">
                    <i class="bi bi-file-earmark-pdf me-1"></i>
                    Boleto
                  </button>
                  <button type="button" class="btn btn-sm btn-light" :disabled="charging" @click="backToChargeQuestion">
                    Voltar
                  </button>
                </div>

                <div v-else-if="chargeData" class="d-flex align-items-center justify-content-between gap-3 flex-wrap">
                  <div>
                    <div class="fw-semibold">
                      Cobrança via {{ chargeData.payment_method === 'pix' ? 'Pix' : 'Boleto' }}
                    </div>
                    <div class="text-muted small">
                      {{ chargeStatusText }}
                    </div>
                  </div>
                  <button
                    v-if="chargeData.payment_method === 'pix' && canReopenCharge"
                    type="button"
                    class="btn btn-sm btn-light-primary"
                    @click="openPixCharge"
                  >
                    Reabrir QR Code
                  </button>
                  <button
                    v-if="chargeData.payment_method === 'bank_slip' && canReopenCharge"
                    type="button"
                    class="btn btn-sm btn-light-primary"
                    @click="openBankSlip"
                  >
                    Abrir boleto
                  </button>
                </div>

                <div v-else class="text-muted small">
                  Guia emitida sem cobrança.
                </div>
              </div>
            </div>

            <div v-else class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-light" data-bs-dismiss="modal">Cancelar</button>
            <div v-if="generatedGuide" class="btn-group">
              <button type="button" class="btn btn-primary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="bi bi-file-earmark-pdf me-2"></i>
                Guia
              </button>
              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" href="#" @click.prevent="openGuidePdf">
                    <i class="bi bi-eye me-2"></i>
                    Abrir em nova aba
                  </a>
                </li>
              </ul>
            </div>
            <button v-else type="submit" class="btn btn-success" :disabled="generating || !guidePreview">
              {{ generating ? 'Emitindo...' : 'Emitir Guia' }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <PixPaymentModal
    ref="pixPaymentModal"
    :pixData="pixModalData"
    @onClose="pixModalData = null"
    @paymentConfirmed="refreshChargeData"
  />

  <TissGuideChargeActionsModal
    ref="chargeActionsModal"
    :guideId="generatedGuide?.id_tiss_guide"
    :chargeData="chargeData"
    :defaultEmail="guidePreview?.patient_email || ''"
    @viewPix="openPixCharge"
  />
</template>

<script>
import {mask} from "vue-the-mask";
import http from "../../helpers/http";
import Alert from "../../helpers/alert";
import Loader from "../../helpers/loader";
import Modal from "../../helpers/modal";
import Download from "../../helpers/download";
import PixPaymentModal from "../../components/PixPaymentModal.vue";
import TissGuideChargeActionsModal from "../../components/TissGuideChargeActionsModal.vue";

export default {
  name: "ModalTissGuideConfirmation",
  emits: ['confirmed', 'cancelled'],
  components: {
    PixPaymentModal,
    TissGuideChargeActionsModal,
  },
  directives: {
    mask,
  },
  data() {
    return {
      modal: null,
      schedule: null,
      guidePreview: null,
      generating: false,
      generatedGuide: null,
      askForCharge: false,
      selectingChargeMethod: false,
      charging: false,
      chargeData: null,
      pixModalData: null,
    };
  },
  computed: {
    place() {
      return this.$store.state.auth.place;
    },
    canReopenCharge() {
      return this.chargeData && !this.chargeData.is_paid && this.chargeData.status !== 'C';
    },
    chargeStatusText() {
      if (!this.chargeData) return '';

      if (this.chargeData.status === 'S') return 'Cobrança paga.';
      if (this.chargeData.status === 'C') return 'Cobrança cancelada.';
      return 'Cobrança pendente.';
    },
    canGenerateChargeFromGuide() {
      const v = parseFloat(this.generatedGuide?.procedure_value ?? 0);
      return v > 5;
    },
  },
  mounted() {
    this.modal = new bootstrap.Modal(document.getElementById('modal_tiss_guide_confirmation'));

    Modal.onAfterClose('#modal_tiss_guide_confirmation', () => {
      this.$emit('cancelled');
    });
  },
  methods: {
    async applyResolvedProcedureValueToPreview(scheduleData) {
      if (!this.guidePreview) {
        return;
      }
      const idProf = scheduleData.id_prof ?? this.schedule?.id_prof;
      const idSpec = scheduleData.id_spec ?? this.schedule?.id_spec;
      const attendanceDate = this.guidePreview.attendance_date;
      if (!idProf || !attendanceDate) {
        return;
      }
      const params = {
        id_prof: idProf,
        attendance_date: attendanceDate,
      };
      if (idSpec) {
        params.id_spec = idSpec;
      }
      const idInsurance = scheduleData.id_insurance ?? this.schedule?.id_insurance;
      if (idInsurance) {
        params.id_insurance = idInsurance;
      }
      const idSupplier =
        scheduleData.id_supplier
        ?? scheduleData.professional?.id_supplier
        ?? null;
      if (idSupplier) {
        params.id_supplier = idSupplier;
      }
      try {
        const res = await http.get(
          `/places/${this.place.id_place}/tiss-guides/resolved-procedure-value`,
          { params }
        );
        if (res.data?.resolved) {
          const v = parseFloat(res.data.procedure_value);
          if (!Number.isNaN(v)) {
            this.guidePreview.procedure_value = v;
          }
        }
        if (res.data?.transfer_resolved) {
          const t = parseFloat(res.data.procedure_transfer_value);
          if (!Number.isNaN(t)) {
            this.guidePreview.procedure_transfer_value = t;
          }
        }
      } catch (err) {
        console.warn('Não foi possível resolver valor do procedimento para preview:', err);
      }
    },
    async open(schedule) {
      this.schedule = schedule;
      this.guidePreview = null;
      this.generating = false;
      this.generatedGuide = null;
      this.askForCharge = false;
      this.selectingChargeMethod = false;
      this.charging = false;
      this.chargeData = null;
      this.pixModalData = null;

      this.modal.show();
      await this.loadPreview();
    },
    async loadPreview() {
      try {
        const response = await http.get(`/places/${this.place.id_place}/schedules/${this.schedule.id_sched}?with=professional,specialty,insurance,visitValue`);
        const scheduleData = response.data;

        // Carregar dados do agendamento e criar preview da guia
        const patient = scheduleData.patient || scheduleData.patientUser || this.schedule?.patient || {};
        const professional = scheduleData.professional || {};
        const specialty = scheduleData.specialty || {};
        const insurance = scheduleData.insurance || {};
        const visitValue = scheduleData.visitValue || {};
        const fallbackProcedure = parseFloat(scheduleData.sched_value || this.schedule?.sched_value || 0);
        const idSupplierResolve = scheduleData.id_supplier ?? professional.id_supplier ?? null;

        this.guidePreview = {
          guide_type: 'CONSULTA', // Padrão: Consulta
          attendance_date: scheduleData.sched_date ? new Date(scheduleData.sched_date).toISOString().split('T')[0] : (this.schedule?.sched_date ? new Date(this.schedule.sched_date).toISOString().split('T')[0] : ''),
          patient_name: patient.patient_name || '',
          patient_cpf: patient.patient_cpf || '',
          professional_name: professional.prof_name || '',
          specialty_name: specialty.spec_name || '',
          insurance_name: insurance.insurance_name || 'Particular',
          card_number: scheduleData.sched_card_number || '',
          procedure_code: String(visitValue.visit_value_proc_code || '').slice(0, 20),
          procedure_value: fallbackProcedure,
          procedure_transfer_value: parseFloat(scheduleData.sched_value || this.schedule?.sched_value || 0),
          observations: scheduleData.sched_tiss_observations || '',
          ...(idSupplierResolve ? { id_supplier: idSupplierResolve } : {}),
        };

        await this.applyResolvedProcedureValueToPreview(scheduleData);
      } catch (e) {
        console.error('Erro ao carregar preview:', e);
        Alert.toastError('Erro ao carregar dados da guia.');
        this.modal.hide();
      }
    },
    async confirm() {
      if (!this.schedule || !this.guidePreview) return;

      this.generating = true;
      Loader.show('Gerando Guia', 'Aguarde...');

      try {
        const payload = {
          guide_type: this.guidePreview.guide_type,
          attendance_date: this.guidePreview.attendance_date,
          procedure_code: String(this.guidePreview.procedure_code ?? '').slice(0, 20),
          procedure_transfer_value: parseFloat(this.guidePreview.procedure_transfer_value ?? 0),
          observations: this.guidePreview.observations,
        };
        if (this.guidePreview.id_supplier) {
          payload.id_supplier = this.guidePreview.id_supplier;
        }

        const response = await http.post(
          `/places/${this.place.id_place}/tiss-guides/from-schedule/${this.schedule.id_sched}`,
          payload
        );

        Alert.toastSuccess('Guia emitida com sucesso!');
        this.generatedGuide = response.data;
        this.askForCharge = true;
        this.$emit('confirmed', this.generatedGuide);
      } catch (e) {
        console.log(e);
        Alert.toastError(e.response?.data?.message || 'Erro ao emitir guia.');
      } finally {
        this.generating = false;
        Loader.close();
      }
    },
    onChargeDecision(hasCharge) {
      if (hasCharge) {
        const v = parseFloat(this.generatedGuide?.procedure_value ?? 0);
        if (!(v > 5)) {
          Alert.toastError('Para gerar cobrança, o valor da guia precisa ser maior que R$ 5,00.');
          return;
        }
      }
      this.askForCharge = false;
      this.selectingChargeMethod = hasCharge;
      if (!hasCharge) {
        this.chargeData = null;
      }
    },
    backToChargeQuestion() {
      this.selectingChargeMethod = false;
      this.askForCharge = true;
    },
    async createCharge(paymentMethod) {
      if (!this.generatedGuide) return;

      const v = parseFloat(this.generatedGuide.procedure_value ?? 0);
      if (!(v > 5)) {
        Alert.toastError('Para gerar cobrança, o valor da guia precisa ser maior que R$ 5,00.');
        return;
      }

      this.charging = true;
      Loader.show('Gerando cobrança', 'Aguarde...');

      try {
        const response = await http.post(
          `/places/${this.place.id_place}/tiss-guides/${this.generatedGuide.id_tiss_guide}/charge`,
          { payment_method: paymentMethod }
        );

        this.generatedGuide = response.data.guide;
        this.chargeData = response.data.charge;
        this.askForCharge = false;
        this.selectingChargeMethod = false;
        this.$emit('confirmed', this.generatedGuide);

        // Em vez de abrir automaticamente, abre o modal pequeno de ações.
        this.$nextTick(() => {
          this.$refs.chargeActionsModal?.open();
        });
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao gerar cobrança da guia.');
      } finally {
        this.charging = false;
        Loader.close();
      }
    },
    async refreshChargeData() {
      if (!this.generatedGuide?.id_tiss_guide) return;

      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/${this.generatedGuide.id_tiss_guide}/charge`
        );
        this.generatedGuide = response.data.guide;
        this.chargeData = response.data.charge;
        this.$emit('confirmed', this.generatedGuide);
      } catch (_) {
      }
    },
    openPixCharge() {
      if (!this.chargeData?.pix_code) return;

      this.pixModalData = {
        pix_code: this.chargeData.pix_code,
        qr_code_base64: this.chargeData.pix_qrcode_img,
        payment_id: this.chargeData.id_card_trans,
        expires_at: this.chargeData.expires_at,
      };

      this.$nextTick(() => {
        this.$refs.pixPaymentModal?.open();
      });
    },
    async openBankSlip() {
      if (!this.generatedGuide) return;

      Loader.show('Abrindo boleto', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/${this.generatedGuide.id_tiss_guide}/charge/bank-slip`,
          { responseType: 'blob' }
        );

        Download.openPdf(response.data);
      } catch (e) {
        Alert.toastError(e.response?.data?.message || 'Erro ao abrir boleto da guia.');
      } finally {
        Loader.close();
      }
    },
    async openGuidePdf() {
      if (!this.generatedGuide) return;

      Loader.show('Gerando PDF', 'Aguarde...');
      try {
        const response = await http.get(
          `/places/${this.place.id_place}/tiss-guides/${this.generatedGuide.id_tiss_guide}/pdf`,
          { responseType: 'blob' }
        );

        Download.openPdf(response.data);
      } catch (e) {
        Alert.toastError('Erro ao abrir PDF da guia.');
      } finally {
        Loader.close();
      }
    },
  },
};
</script>
